var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1435,
    height: 1022,
    viewBox: "0 0 1435 1022",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1435,
    height: 1022,
    fill: "#1E82DE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1435,
    height: 1022,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.0278746,
    height: 0.0234834
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4_4",
    transform: "scale(0.000696864 0.000978474)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4_4",
    width: 40,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYCAYAAACIhL/AAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEqSURBVHgBvddLDoIwEAbgmSYmHoOreANXhrjyaC5ZcgOPIscwIQFnXBVoaeeB3QjWv/PF6qQgCEbbzs0U4DUjNHQ7jCe49E8c4vkPvfZd9N6DMiNlgDIzZSbKRPOlgVdaIC5iRS4+a8RxPpxoAUbWhjoqEKgQUkG6bXJ5Dxznw14RLdILx3m83ed3zXYlF0ps95kuvHCcDzXblRupb9ITx3kEkP3wkwsv8+CF4zxmiuiRdO2F4zlMFjEg133QgvsB133QipSMEi7ZB2v73D9w2T54NLIWx/MhhzgKKcEV+6A3Uoqr7oMefxwNTtQHLUgtjudEfVCDtOA2QG+kFZcEeiE9cFmgFemF2wVqkaXzoPQwuwvUIHlBL1wVUIEEL1w1UISE7XnQ8ozyBZN6KxtKIF9iAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.03112889a005495d3cedebde7ff40644.svg";
export { ForwardRef as ReactComponent };